import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/authContext";
import { Button } from "../../components/ui/button";

export const SubscriptionInactivePage = () => {
  const { workspace, logout: logoutAuth } = useAuth();
  const navigate = useNavigate();

  if (workspace?.subscriptionStatus !== "Inactive") {
    return <Navigate to="/dashboard" />;
  }

  const logout = () => {
    logoutAuth();
    navigate("/signin");
  };

  return (
    <div className="h-screen w-screen bg-[url('/gradient_bg.png')] bg-no-repeat bg-top bg-cover">
      <div className="flex h-screen justify-center items-center">
        <div className="bg-white p-8 rounded-sm shadow-2xl z-10 w-96 border border-stone-100">
          <div className="flex flex-col gap-4">
            <img src="/logo_white_bg.svg" alt="logo" className="w-20" />
            <div>
              <div className="text-2xl font-semibold">
                Subscription Inactive
              </div>
              <div className="text-font-secondary">
                Your subscription is currently inactive. Please contact support
                for more information.
              </div>
            </div>
            <div className="flex gap-2">
              <a href="mailto:founders@midship.ai">
                <Button>Contact Support</Button>
              </a>
              <Button variant="outline" onClick={logout}>
                Logout
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
